module.exports = __webpack_public_path__ + "img/C03TechCarpentomChampion_ua.b949cc73.webp";